/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ArtifactActiveWidgetContext } from './ArtifactActiveWidgetContext';
import {
    instanceOfArtifactActiveWidgetContext,
    ArtifactActiveWidgetContextFromJSON,
    ArtifactActiveWidgetContextFromJSONTyped,
    ArtifactActiveWidgetContextToJSON,
} from './ArtifactActiveWidgetContext';
import type { ArtifactReasoning } from './ArtifactReasoning';
import {
    instanceOfArtifactReasoning,
    ArtifactReasoningFromJSON,
    ArtifactReasoningFromJSONTyped,
    ArtifactReasoningToJSON,
} from './ArtifactReasoning';
import type { ArtifactToolCallRequest } from './ArtifactToolCallRequest';
import {
    instanceOfArtifactToolCallRequest,
    ArtifactToolCallRequestFromJSON,
    ArtifactToolCallRequestFromJSONTyped,
    ArtifactToolCallRequestToJSON,
} from './ArtifactToolCallRequest';
import type { ArtifactToolCallResponse } from './ArtifactToolCallResponse';
import {
    instanceOfArtifactToolCallResponse,
    ArtifactToolCallResponseFromJSON,
    ArtifactToolCallResponseFromJSONTyped,
    ArtifactToolCallResponseToJSON,
} from './ArtifactToolCallResponse';
import type { ArtifactWidgetCmaDetails } from './ArtifactWidgetCmaDetails';
import {
    instanceOfArtifactWidgetCmaDetails,
    ArtifactWidgetCmaDetailsFromJSON,
    ArtifactWidgetCmaDetailsFromJSONTyped,
    ArtifactWidgetCmaDetailsToJSON,
} from './ArtifactWidgetCmaDetails';
import type { ArtifactWidgetListingDetails } from './ArtifactWidgetListingDetails';
import {
    instanceOfArtifactWidgetListingDetails,
    ArtifactWidgetListingDetailsFromJSON,
    ArtifactWidgetListingDetailsFromJSONTyped,
    ArtifactWidgetListingDetailsToJSON,
} from './ArtifactWidgetListingDetails';
import type { ArtifactWidgetListingsSearch } from './ArtifactWidgetListingsSearch';
import {
    instanceOfArtifactWidgetListingsSearch,
    ArtifactWidgetListingsSearchFromJSON,
    ArtifactWidgetListingsSearchFromJSONTyped,
    ArtifactWidgetListingsSearchToJSON,
} from './ArtifactWidgetListingsSearch';

/**
 * @type MessageArtifactsInner
 * 
 * @export
 */
export type MessageArtifactsInner = { kind: 'active-widget-context' } & ArtifactActiveWidgetContext | { kind: 'reasoning' } & ArtifactReasoning | { kind: 'tool-call-request' } & ArtifactToolCallRequest | { kind: 'tool-call-response' } & ArtifactToolCallResponse | { kind: 'widget-cma-details' } & ArtifactWidgetCmaDetails | { kind: 'widget-listing-details' } & ArtifactWidgetListingDetails | { kind: 'widget-listings-search' } & ArtifactWidgetListingsSearch;

export function MessageArtifactsInnerFromJSON(json: any): MessageArtifactsInner {
    return MessageArtifactsInnerFromJSONTyped(json, false);
}

export function MessageArtifactsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageArtifactsInner {
    if (json == null) {
        return json;
    }
    switch (json['kind']) {
        case 'active-widget-context':
            return Object.assign({}, ArtifactActiveWidgetContextFromJSONTyped(json, true), { kind: 'active-widget-context' } as const);
        case 'reasoning':
            return Object.assign({}, ArtifactReasoningFromJSONTyped(json, true), { kind: 'reasoning' } as const);
        case 'tool-call-request':
            return Object.assign({}, ArtifactToolCallRequestFromJSONTyped(json, true), { kind: 'tool-call-request' } as const);
        case 'tool-call-response':
            return Object.assign({}, ArtifactToolCallResponseFromJSONTyped(json, true), { kind: 'tool-call-response' } as const);
        case 'widget-cma-details':
            return Object.assign({}, ArtifactWidgetCmaDetailsFromJSONTyped(json, true), { kind: 'widget-cma-details' } as const);
        case 'widget-listing-details':
            return Object.assign({}, ArtifactWidgetListingDetailsFromJSONTyped(json, true), { kind: 'widget-listing-details' } as const);
        case 'widget-listings-search':
            return Object.assign({}, ArtifactWidgetListingsSearchFromJSONTyped(json, true), { kind: 'widget-listings-search' } as const);
        default:
            return json;
    }
}

export function MessageArtifactsInnerToJSON(json: any): any {
    return MessageArtifactsInnerToJSONTyped(json, false);
}

export function MessageArtifactsInnerToJSONTyped(value?: MessageArtifactsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['kind']) {
        case 'active-widget-context':
            return Object.assign({}, ArtifactActiveWidgetContextToJSON(value), { kind: 'active-widget-context' } as const);
        case 'reasoning':
            return Object.assign({}, ArtifactReasoningToJSON(value), { kind: 'reasoning' } as const);
        case 'tool-call-request':
            return Object.assign({}, ArtifactToolCallRequestToJSON(value), { kind: 'tool-call-request' } as const);
        case 'tool-call-response':
            return Object.assign({}, ArtifactToolCallResponseToJSON(value), { kind: 'tool-call-response' } as const);
        case 'widget-cma-details':
            return Object.assign({}, ArtifactWidgetCmaDetailsToJSON(value), { kind: 'widget-cma-details' } as const);
        case 'widget-listing-details':
            return Object.assign({}, ArtifactWidgetListingDetailsToJSON(value), { kind: 'widget-listing-details' } as const);
        case 'widget-listings-search':
            return Object.assign({}, ArtifactWidgetListingsSearchToJSON(value), { kind: 'widget-listings-search' } as const);
        default:
            return value;
    }
}

